import {
  Modal,
  Input,
  DatePicker,
  Select,
  Form,
  Button,
  Radio,
  Checkbox,
} from "antd";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import { useState } from "react";
import api from "../../services/api";
import toast from "react-hot-toast";

dayjs.extend(utc);

const { Option } = Select;

const CreateOfferModal = ({ isOpen, onCancel, subscriptions }) => {
  const [form] = Form.useForm();
  const [isLoading, setIsLoading] = useState(false);

  const handleSubmit = async (values) => {
    try {
      setIsLoading(true);
      const formatted = {
        isActive: values.active,
        type: values.offerType,
        startDate: dayjs(values.startDate).utc().format("YYYY-MM-DD"),
        endDate: dayjs(values.endDate).utc().format("YYYY-MM-DD"),
        metadata: [
          {
            subscriptionId: values?.subscription,
            discountPercentage: values.discountPercentage,
          },
        ],
      };
      console.log("Submitted:", formatted);
      const req = await api.post("/limitedTimeOffers", formatted);
      if (req.status === 201) {
        toast.success("Offer created!");
      }
      setIsLoading(false);
      onCancel();
    } catch (error) {
      console.log(error);
      setIsLoading(false);
    }
  };

  return (
    <Modal
      title="Create Offer"
      closable
      open={isOpen}
      onCancel={onCancel}
      width={600}
      footer={null}
      destroyOnClose={true}
      style={{ top: 100 }}
    >
      <Form
        form={form}
        layout="vertical"
        onFinish={handleSubmit}
        className="row px-1"
      >
        <div className="col-6">
          <Form.Item
            name="startDate"
            label="Start Date"
            rules={[{ required: true, message: "Select start date" }]}
          >
            <DatePicker
              style={{ width: "100%" }}
              format="YYYY-MM-DD"
              placeholder="Select start date"
              disabledDate={(current) =>
                current && current < dayjs().startOf("day")
              }
            />
          </Form.Item>
        </div>

        <div className="col-6">
          <Form.Item
            name="endDate"
            label="End Date"
            rules={[{ required: true, message: "Select end date" }]}
          >
            <DatePicker
              style={{ width: "100%" }}
              format="YYYY-MM-DD"
              placeholder="Select end date"
              disabledDate={(current) =>
                current && current < dayjs().add(1, "day").startOf("day")
              }
            />
          </Form.Item>
        </div>

        <div className="col-12">
          <Form.Item
            name="offerType"
            label="Offer Type"
            rules={[{ required: true, message: "Please select an offer type" }]}
          >
            <Select placeholder="Select offer type">
              <Option value="DISCOUNT">Discount</Option>
            </Select>
          </Form.Item>
        </div>

        <div className="col-12">
          <Form.Item
            name="discountPercentage"
            label="Discount Percentage (%)"
            rules={[
              { required: true, message: "Enter discount percentage" },
              {
                validator: (_, value) =>
                  value >= 0 && value <= 100
                    ? Promise.resolve()
                    : Promise.reject("Must be between 0 and 100"),
              },
            ]}
          >
            <Input type="number" placeholder="e.g. 20" />
          </Form.Item>
        </div>

        <div className="col-12">
          <Form.Item
            name="subscription"
            label="Subscription"
            rules={[
              { required: true, message: "Please select a subscription" },
            ]}
          >
            <Select placeholder="Select subscription">
              {subscriptions?.map((x) => (
                <Option key={x?.id} value={x?.id}>
                  {x?.name}
                </Option>
              ))}
            </Select>
          </Form.Item>
        </div>

        <div className="col-12">
          <Form.Item name="active" valuePropName="checked">
            <Checkbox>Active</Checkbox>
          </Form.Item>
        </div>

        <div className="col-12 text-end">
          <Button
            htmlType="submit"
            size="large"
            className="btn_contained fs_12 px-2 text-white"
            loading={isLoading}
          >
            Create
          </Button>
        </div>
      </Form>
    </Modal>
  );
};

export default CreateOfferModal;
